module.exports = __webpack_public_path__ + "static/media/20.6ea41375.png";